<template>
    <Modal v-if="true" :allowClose="false">
        <template #body>
            <div class="flex flex-col items-center">
                <div class="flex flex-col justify-start">
                    <p class="font-[Inter] text-left font-semibold text-base text-[#444C58]">Before entering WonsultingAI... </p>
                    <p class="font-[Inter] mt-4 text-left font-semibold text-2xl text-[#2A8176]">Learn More About Our Services!</p>
                    <p class="font-[Inter] text-left font-normal text-sm text-[#444C58]">Book a call to see how Wonsulting can help you.</p>
                </div>

                <!-- Calendly inline widget begin -->
                    <div class="calendly-inline-widget" :data-url="`https://calendly.com/wonsulting-talk-to-us/learn-about-wonsulting-services-clone?hide_event_type_details=${how_quickly_looking_new_job == '4+ months' ? 1 : 0}&hide_gdpr_banner=1`" style="min-width:320px;height:430px;"></div>
                <!-- Calendly inline widget end -->

                <button :class="[ghostButtonStyle]" @click="handleClose">No Thanks</button>
            </div>
        </template>
    </Modal>
</template>

<script setup>
import Modal from "../components/modal.vue";
import { ghostButtonStyle } from "../utils/styles";
import { onMounted } from 'vue'

import { setAuthState } from "../composables/auth";

import { ref } from 'vue'

const emit = defineEmits(['close'])
const { getUser } = setAuthState();

const how_quickly_looking_new_job = ref(getUser()?.options?.how_quickly_looking_new_job ?? null);

const handleClose = () => {
    emit('close')
}

onMounted(async() => {
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js')
    recaptchaScript.setAttribute('async', true);
    document.head.appendChild(recaptchaScript)
})
</script>

<style>
.calendly-inline-widget {
    height: 430px !important;
}
</style>
